import VisualizarCompraAnexos from './VisualizarCompraAnexos';

export default VisualizarCompraAnexos;
